import { render, staticRenderFns } from "./explanationStep3.vue?vue&type=template&id=1c5896a4&scoped=true&"
import script from "./explanationStep3.vue?vue&type=script&lang=js&"
export * from "./explanationStep3.vue?vue&type=script&lang=js&"
import style0 from "./explanationStep3.vue?vue&type=style&index=0&id=1c5896a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5896a4",
  null
  
)

export default component.exports